import { render, staticRenderFns } from "./ItalicSubheader.vue?vue&type=template&id=4ede9a10&scoped=true&"
import script from "./ItalicSubheader.vue?vue&type=script&lang=js&"
export * from "./ItalicSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede9a10",
  null
  
)

export default component.exports